import {createSlice, PayloadAction} from "@reduxjs/toolkit"
import {limitOptionsSelect} from "../helps/optionsSelect"
import {asyncCreator} from "./sliceHelper"
import {WSCompany} from "../types/WebSocketTypes"
import {CompaniesResponse, CompanyResponse} from "../models/response"
import {companyApi} from "../api/companyApi"

export type CompaniesFilter = {
    limit: number
    offset: number
}

export type CompaniesFilterQuery = {
    status?: "-1" | "0" | "1"
    search?: string
}

type InitialStateType = {
    companies: null | CompaniesResponse
    company: null | CompanyResponse
    filter: CompaniesFilter & CompaniesFilterQuery
    sideFilter: CompaniesFilter & CompaniesFilterQuery
    ws: WSCompany | null
}

const initialState: InitialStateType = {
    companies: null,
    company: null,
    filter: {
        limit: limitOptionsSelect[0].value,
        offset: 0,
    },
    sideFilter: {
        limit: limitOptionsSelect[0].value,
        offset: 0,
    },
    ws: null,
}

export const companyReducer = createSlice({
    name: 'companyReducer',
    initialState,
    reducers: {
        setCompanies(state, {payload}) {
            state.companies = payload
        },
        setCompany(state, {payload}) {
            state.company = payload
        },
        addCompany(state, {payload}) {
            if (state.companies) {
                state.companies = {
                    total: state.companies.total += 1,
                    data: [payload, ...state.companies.data],
                }
            }
        },
        editCompany(state, {payload}: PayloadAction<CompanyResponse>) {
            let index = state.companies?.data.findIndex(i => i.id === payload.id)
            if (index !== undefined && state.companies) state.companies.data[index] = payload
            if (state.company) state.company = payload
        },
        setCompaniesFilter(state, {payload}) {
            state.filter = payload
        },
        setCompanySideFilter(state, {payload}) {
            state.sideFilter = payload
        },
        setWSCompany(state, {payload}: PayloadAction<WSCompany | null>) {
            state.ws = payload
        },
    },
})

export const {setCompanies, setCompany, addCompany, editCompany, setCompaniesFilter, setCompanySideFilter, setWSCompany} = companyReducer.actions

export default companyReducer.reducer

export const getCompanies = asyncCreator
('companyReducer/getCompanies', companyApi.getCompanies, setCompanies)

export const getCompany = asyncCreator
('companyReducer/getCompany', companyApi.getCompany, setCompany)

export const createCompany = asyncCreator
('companyReducer/createCompany', companyApi.createCompany, addCompany, 'Компания успешно создана')

export const changeCompany = asyncCreator
('companyReducer/changeCompany', companyApi.changeCompany, editCompany)

export const deleteCompany = asyncCreator
("companyReducer/deleteCompany", companyApi.deleteCompany)